import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { dateFromUnixTimestamp as h, rehydrateDateAfterJsonization as w } from "../../util/date-utils.js";
import r from "../../../shared-lib/braze-shared-lib.js";
import Gt from "./trigger-condition.js";
import { validateValueIsFromEnum as F } from "../../util/code-utils.js";

var ut = /*#__PURE__*/function () {
  function ut(t, i, s, e, r, l, o, n, h, a, u, d) {
    _classCallCheck(this, ut);

    this.id = t, this.Ph = i || [], void 0 === s && (s = null), this.startTime = s, void 0 === e && (e = null), this.endTime = e, this.priority = r || 0, this.type = l, this.bh = n || 0, null == a && (a = 1e3 * (this.bh + 30)), this.vi = a, this.data = o, null == h && (h = ut.jh), this.$h = h, this.xh = u, this.Ch = d || null;
  }

  _createClass(ut, [{
    key: "Fh",
    value: function Fh(t) {
      return null == this.Ch || this.$h !== ut.jh && t - this.Ch >= 1e3 * this.$h;
    }
  }, {
    key: "Jh",
    value: function Jh(t) {
      this.Ch = t;
    }
  }, {
    key: "Vh",
    value: function Vh(t) {
      var i = t + 1e3 * this.bh;
      return Math.max(i - new Date().valueOf(), 0);
    }
  }, {
    key: "kh",
    value: function kh(t) {
      var i = new Date().valueOf() - t,
          s = null == t || isNaN(i) || null == this.vi || i < this.vi;
      return s || r.D.info("Trigger action ".concat(this.type, " is no longer eligible for display - fired ").concat(i, "ms ago and has a timeout of ").concat(this.vi, "ms.")), !s;
    }
  }, {
    key: "ss",
    value: function ss() {
      var t = [];

      for (var i = 0; i < this.Ph.length; i++) {
        t.push(this.Ph[i].ss());
      }

      return {
        i: this.id,
        c: t,
        s: this.startTime,
        e: this.endTime,
        p: this.priority,
        t: this.type,
        da: this.data,
        d: this.bh,
        r: this.$h,
        tm: this.vi,
        ss: this.xh,
        ld: this.Ch
      };
    }
  }], [{
    key: "fromJson",
    value: function fromJson(t) {
      var i = t.id,
          s = [];

      for (var _i = 0; _i < t.trigger_condition.length; _i++) {
        s.push(Gt.fromJson(t.trigger_condition[_i]));
      }

      var e = h(t.start_time),
          r = h(t.end_time),
          l = t.priority,
          o = t.type,
          n = t.delay,
          a = t.re_eligibility,
          u = t.timeout,
          d = t.data,
          m = t.min_seconds_since_last_trigger;
      return F(ut.gi, o, "Could not construct Trigger from server data", "Trigger.Types") ? new ut(i, s, e, r, l, o, d, n, a, u, m) : null;
    }
  }, {
    key: "yn",
    value: function yn(t) {
      var i = [];

      for (var s = 0; s < t.c.length; s++) {
        i.push(Gt.yn(t.c[s]));
      }

      return new ut(t.i, i, w(t.s), w(t.e), t.p, t.t, t.da, t.d, t.r, t.tm, t.ss, t.ld);
    }
  }]);

  return ut;
}();

export { ut as default };
ut.jh = -1, ut.gi = {
  mi: "inapp",
  qh: "templated_iam"
};